webpackJsonp([167545422930614],{

/***/ 1182:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/terms_conditions/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-terms-conditions-89fc4dec9a9b8169d047.js